class FAQs extends HTMLElement {
    constructor() {
        super();

        this.filter = document.getElementById('haloFAQsFilter');
        this.faqsPopup = document.getElementById('halo-faqs-popup');

        if (this.filter) {
            this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
            this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
            this.filterDropdownArrow = this.filterToggle.querySelector('[data-dropdown-arrow]');

            if (this.filterToggle) {
                this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
            }

            if (this.filterDropdown.querySelector('.text')) {
                this.filterDropdown.querySelectorAll('.text').forEach(filterButton => {
                    filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                });
            }
        }

        if (this.querySelector('.faqs')) {
            this.querySelectorAll('.card-header').forEach(headerButton => {
                headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
            });
        }

        if (!document.body.classList.contains('template-index')) {
            document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        }
    }

    onClickFilterHandler() {
        this.filterDropdown.classList.toggle('is-show');
        this.filterDropdownArrow.classList.toggle('active');
    }

    onClickFilterButtonHandler(event) {
        const btn = event.target.closest('li');
        if (!btn.classList.contains('is-active')) {
            const filterValue = btn.getAttribute('data-value');
            const filterText = event.target.innerText;

            this.filterToggle.querySelector('.text').innerText = filterText;
            this.filterDropdown.querySelectorAll('li').forEach(el => el.classList.remove('is-active'));
            btn.classList.add('is-active');

            this.querySelectorAll('.faqs-paragraph').forEach(element => {
                element.classList.toggle('is-hidden', element.getAttribute('id') !== filterValue);
                element.classList.toggle('is-active', element.getAttribute('id') === filterValue);
            });

            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active');
        }
    }

    onClickHeaderButtonHandler(event) {
        const btn = event.currentTarget;
        const content = btn.nextElementSibling;
        
        this.querySelectorAll('.card-header').forEach(header => {
            if (header !== btn) {
                header.classList.add('collapsed');
                header.nextElementSibling.style.maxHeight = null;
            }
        });
        
        btn.classList.toggle('collapsed');
        content.style.maxHeight = btn.classList.contains('collapsed') ? null : content.scrollHeight + 'px';
    }

    onBodyClickEvent(event) {
        if (!event.target.closest('[data-faqs-filter]') && this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active');
        }
    }
}

customElements.define('faqs-item', FAQs);